import {ReactNode} from "react";

interface TitleBoxProps {
    children: ReactNode
    extraClassNames?: string
    lineHidden: boolean
}

export function TitleBox(props: TitleBoxProps) {
    return (
        <div className={`flex flex-col items-center ${props.extraClassNames ?? ""}`}>
            <div className={`flex flex-col justify-start w-full text-center`}>
                {props.children}
            </div>
        </div>
    )
}